import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getRole, Roles } from "../../../../Constants/Roles";
import { getSchoolsListRequest } from "../../../../Backend";
import UserInfoData from "../../../../Components/UserInfoData/UserInfoData";
import { PetitionSchoolModal } from "./PetitionSchoolModal/PetitionSchoolModal";
import "./SchoolProfilePage.scss";
import { WebRoutes } from "../../../../Constants";

export function SchoolProfilePage() {
  const userData = useSelector((state) => state.user.credentials);
  const [t] = useTranslation();
  const navigate = useNavigate();

  const [showSchoolPetitionModal, setShowSchoolPetitionModal] = useState(false);

  const [userInfo, setUserInfo] = useState({
    id: "",
    firstName: "",
    lastName: "",
    preposition: "",
    role: 0,
    schoolId: "",
    softEmail: "",
    course: "",
    class: "",
    iddinkCode: "",
    email: "",
  });

  const [schoolList, setSchoolList] = useState([]);

  useEffect(() => {
    if (
      userData.role === Roles.SchoolManager ||
      userData.role === Roles.SchoolBookManager ||
      userData.role === Roles.IddinkSchoolManager
    ) {
      parseUserInfo();
    } else {
      switch (userData.role) {
        case Roles.Admin:
          navigate(WebRoutes.UserHomePage);
          break;

        case Roles.Student:
          navigate(WebRoutes.StudentHomePage);
          break;

        default:
          navigate(-1);

          break;
      }
    }
  }, []);

  const getSchoolsList = async () => {
    const resp = await getSchoolsListRequest(userData.id);

    if (resp.success) {
      setSchoolList(resp.data);
    }
  };

  const parseUserInfo = () => {
    setUserInfo({ ...userInfo, ...userData, isAdmin: getRole(userInfo.role) });
    getSchoolsList();
  };

  const renderSchoolsList = () => {
    let htmlSchoolList = [];
    schoolList.forEach((school) => {
      htmlSchoolList.push(
        <div className="school-item" key={school.id}>
          <span className="name">
            <span className="schoolNumber">{school.schoolNumber}</span>
            {school.name}
          </span>
        </div>
      );
    });
    return htmlSchoolList;
  };

  return (
    <div className="school-profile-page">
      <div className="header">
        <span className="title">{t("ProfilePageTitle")}</span>
      </div>

      <div className="block-wrapper">
        <div className="block-info">
          <UserInfoData userInfo={userInfo} />
          {!userData.isExternalUser && (
            <div className="button-wrapper">
              <Button
                className="button"
                onClick={() => navigate(WebRoutes.ChangePasswordPage)}
              >
                {t("ChangePassword")}
              </Button>
            </div>
          )}
        </div>

        <div className="block-info">
          <span className="subtitle">
            {t("SchoolsManaging")}
            {" (" + schoolList.length + ")"}
          </span>
          <div className="school-list">
            {schoolList.length > 0 ? (
              renderSchoolsList()
            ) : (
              <span className="subtitle">
                {t("NoSchoolsManaging")}
              </span>
            )}
          </div>
          {userData.role !== Roles.IddinkSchoolManager && (
            <div className="button-wrapper" key="ShowSchoolModalBtn">
              <Button
                className="save"
                onClick={() => setShowSchoolPetitionModal(true)}
              >
                {t("ShowUserPetitionsBtn")}
              </Button>
            </div>
          )}
        </div>
      </div>

      {showSchoolPetitionModal && (
        <PetitionSchoolModal
          user={userData}
          show={showSchoolPetitionModal}
          onHide={() => setShowSchoolPetitionModal(false)}
        />
      )}
    </div>
  );
}
